import { LoaderManagerService } from '@anecdotes/design-system/loaders';
import {
  ModalWindowService,
  StatusModalWindowInputKeys,
  StatusType,
  StatusWindowModalComponent,
} from '@anecdotes/design-system/modals';
import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, SkipSelf } from '@angular/core';
import { Observable, firstValueFrom } from 'rxjs';
import { TrustCenterModalEnum } from '../../../../constants';
import { TrustCenterFacadeService, TrustCenterInfoResponse } from '@anecdotes/shared-trust-center';
import { OverviewEditSidePanelComponent } from '../overview-edit-side-panel/overview-edit-side-panel.component';

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OverviewComponent implements OnInit, OnDestroy {
  trustCenterInfo$: Observable<TrustCenterInfoResponse>;
  editing$: Observable<boolean>;

  constructor(
    @SkipSelf() private loaderManager: LoaderManagerService,
    private modalWindowService: ModalWindowService,
    private trustCenterFacadeService: TrustCenterFacadeService,
  ) {}

  ngOnInit(): void {
    this.trustCenterInfo$ = this.trustCenterFacadeService.getTrustCenterInfo();
    this.editing$ = this.trustCenterFacadeService.isEditing();
  }

  ngOnDestroy(): void {
    this.loaderManager.hide();
  }

  buildTranslationKey(key: string): string {
    return `trustCenter.${key}`;
  }

  async openEditOverviewSidepanel(): Promise<void> {
    this.modalWindowService.close();

    this.modalWindowService.openMediumSlidePanel({
      componentsToSwitch: [
        {
          id: 'app-overview-edit-side-panel',
          componentType: OverviewEditSidePanelComponent,
          contextData: {
            trustCenterInfo: await firstValueFrom(this.trustCenterInfo$),
          },
        },
        {
          id: TrustCenterModalEnum.ErrorModal,
          componentType: StatusWindowModalComponent,
          contextData: {
            [StatusModalWindowInputKeys.statusType]: StatusType.ERROR,
            [StatusModalWindowInputKeys.closeModalOnClick]: true,
            [StatusModalWindowInputKeys.translationKey]: this.buildTranslationKey('overview.errorModal'),
          },
        },
      ],
      options: {
        closeOnEsc: true,
      },
    });
  }
}
